<template>
    <div class="house-component js-house-component">
        <div class="house-component-inner js-houses-component-eq-height">
            <button v-if="!isProjectClosed" type="button" class="btn btn--none house-component-remove" v-on:click="deleteHouse(house.id)">
                <span class="spinner spinner--black glyphicon glyphicon-remove"></span>
            </button>
            <h3 class="house-title">
                <span class="display-house-title" :class="{enabled: !isProjectClosed}" v-if="!editingHouseName"
                      v-on:click="startEditName()">{{ name }}</span>
                <input class="house-name-input" type="text" :ref="`house-${houseId}`" :id="`house-${houseId}`"
                       v-show="editingHouseName" v-model="name" v-on:keyup.enter="stopEditName()"
                       v-on:blur="stopEditName()">
            </h3>
            <div class="corona-attributes" v-if="isCorona">
                {{ coronaAttributes(house) }}
            </div>

            <div class="house-component-inputs js-house-component-inputs">
                <div class="js-floors-input">
                    <div class="integer-input">
                        <label class="control-label integer-input-label">Våningar</label>
                        <button type="button" class="btn btn--round"
                                v-bind:disabled="!isFloorDecreasable || isProjectClosed" v-on:click="decreaseFloor()">
                            <span class="glyphicon glyphicon-minus"></span>
                        </button>
                        <span class="integer-input-value">{{ house.floors }} </span>
                        <button type="button" class="btn btn--round"
                                v-bind:disabled="!isFloorIncreasable || isProjectClosed" v-on:click="increaseFloor()">
                            <span class="glyphicon glyphicon-plus"></span>
                        </button>
                    </div>
                </div>

                <house-apartment v-for="apartment in house.apartments"
                                 :key="apartment.id"
                                 :apartmentId="apartment.id"
                                 :houseId="house.id"
                                 :apartmentSizeDict="apartmentSizes"
                                 :debounceSave="debounceSave"/>

            </div>
        </div>
    </div>
</template>

<script>
    import Store from "../store";
    import HouseApartment from "./houseApartment"
    import {mapGetters, mapActions} from "vuex"
    import _ from "lodash"

    export default {
        props: {
            houseId: {type: Number, required: true},
            index: {type: Number, required: true}
        },

        data() {
            return {
                editingHouseName: false
            };
        },

        computed: {
            ...mapGetters([
                'apartmentSizes',
                'procurementModel'
            ]),
            house() {
                return Store.getters.findHouseById(this.houseId);
            },
            name: {
                get: function () {
                    if (this.house.name || this.editingHouseName)
                        return this.house.name;

                    return `Hus ${this.index + 1}`;
                },
                set: function (newValue) {
                    Store.commit("updateHouseName", {houseId: this.house.id, newValue});
                }
            },
            isFloorDecreasable() {
                return this.house.floors > this.house.referenceHouse.minNumberOfFloors;
            },
            isFloorIncreasable() {
                return this.house.floors < this.house.referenceHouse.maxNumberOfFloors;
            },
            isProjectClosed() {
                return Store.getters.isProjectClosed;
            },
            isCorona() {
                return this.procurementModel === 4
            }
        },

        methods: {
            ...mapActions([
                "removeHouse",
                "updateHouses",
            ]),
            decreaseFloor() {
                this.$store.commit("changeFloor", {houseId: this.house.id, delta: -1})
                this.house.apartments.forEach((apartment) => {
                    const matchingRefApartment = this.house.referenceHouse.standardFloorApartments
                        .find((a) => a.size === apartment.apartmentSize && a.area === apartment.area)
                    if (!matchingRefApartment) return

                    this.$store.commit("updateApartment", {
                        houseId: this.house.id,
                        apartmentId: apartment.id,
                        count: apartment.count - matchingRefApartment.count,
                        minCount: apartment.minCount - matchingRefApartment.count,
                        maxCount: apartment.maxCount - matchingRefApartment.count,
                    })
                })
                this.debounceSave()
            },
            increaseFloor() {
                this.$store.commit({type: "changeFloor", houseId: this.house.id, delta: 1})
                this.house.apartments.forEach((apartment) => {
                    const matchingRefApartment = this.house.referenceHouse.standardFloorApartments
                        .find((a) => a.size === apartment.apartmentSize && a.area === apartment.area)
                    if (!matchingRefApartment) return

                    this.$store.commit("updateApartment", {
                        houseId: this.house.id,
                        apartmentId: apartment.id,
                        count: apartment.count + matchingRefApartment.count,
                        minCount: apartment.minCount + matchingRefApartment.count,
                        maxCount: apartment.maxCount + matchingRefApartment.count,
                    })
                })
                this.debounceSave()
            },
            deleteHouse() {
                this.removeHouse({houseId: this.house.id});
            },
            startEditName() {
                if (this.isProjectClosed)
                    return
                this.editingHouseName = true
                setTimeout(() => {
                    this.$refs[`house-${this.houseId}`].focus()
                }, 200)
            },
            stopEditName() {
                this.editingHouseName = false
                this.debounceSave()
            },
            debounceSave: _.debounce(function () {
                this.updateHouses()
            }, 2000),
            coronaAttributes(house) {
                if (house) {
                    if (house.houseConstructionType === "lowRise")
                        return `Lamellhus ${house.hasExteriorCorridor ? "med loftgång" : ""}`
                    else
                        return "Punkthus"
                }
            }
        },

        components: {
            HouseApartment,
        },
    }
</script>

<style lang="scss">
    // SCSS is found in houses-component.scss and is shared with other House non-Vue component


    .corona-attributes {
        position: absolute;
        top: 140px
    }
</style>



// WEBPACK FOOTER //
// assets/vue/houseModel/components/house.vue